import React, { useState } from "react";
import "./Sidebar.css";
import { Navigate, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import SplitButton from "react-bootstrap/SplitButton";

const Sidebar = ({ wealthActive, walletActive }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("wealth_user"))?.data
  );
  const [showSidebar, setShowSidebar] = useState(true);
  console.log("showDropdown", showDropdown);
  const navigate = useNavigate();
  const goToAdminUser = () => {
    navigate("/");
  };
  const goToContractorAccount = () => {
    navigate("/contractoraccount");
  };
  const goToAccount = () => {
    navigate("/account");
  };

  const goToCouponPage = () => {
    navigate("/coupon");
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const goToTwofa = () => {
    if (
      (user?.enableOn == true || user?.enableOn == "true") &&
      (user?.twoFaRequest == "false" ||
        user?.twoFaRequest == false ||
        user?.twoFaRequest == null)
    ) {
      navigate("/disable-twofa");
    } else if (
      (user?.enableOn == false ||
        user?.enableOn == "false" ||
        user?.enableOn == null) &&
      (user?.twoFaRequest == true || user?.twoFaRequest == "true")
    ) {
      navigate("/disable-request");
    } else if (
      (user?.enableOn == false ||
        user?.enableOn == "false" ||
        user?.enableOn == null) &&
      (user?.twoFaRequest == false ||
        user?.twoFaRequest == "false" ||
        user?.twoFaRequest == null)
    ) {
      navigate("/enable-twofa");
    } else {
      navigate("/disable-twofa");
    }
  };

  const goToTransation = () => {
    navigate("/transation");
  };

  const goToInvoicePage = () => {
    navigate("/invoice");
  };

  const goToReportsPage = () => {
    navigate("/cleaner-payment");
  };

  const logoutFun = () => {
    navigate("/login");
  };

  const pathname = window.location.pathname;

  return (
    <>
      {/* <div
        id="page-content-wrapper"
        onClick={() => setShowSidebar(!showSidebar)}
      >
        <span href="#menu-toggle" id="menu-toggle">
          &#9776;
        </span>
      </div> */}

      {showSidebar && (
        <div className={showDropdown ? "sidebar dropdown-active" : "sidebar"}>
          <div className="sidebar-wrapper">
            <div
              className={pathname == "/" ? "sidebar-tab active" : "sidebar-tab"}
            >
              <div className="sidebar-tab-icon">
                <img
                  onClick={goToAdminUser}
                  src="./images/icons/sidebar-1.svg"
                  alt="icon"
                />
              </div>
              <p onClick={goToAdminUser}> Admin User </p>
            </div>
            <div
              className={
                pathname == "/account" ||
                pathname == "/account-detail" ||
                pathname == "/account-transation" ||
                pathname == "/contractor-edti-profile" ||
                pathname == "/contractoraccount" ||
                pathname == "/contractoraccount-detail" ||
                pathname == "/services-commercial" ||
                pathname == "/booking-confirmation" ||
                pathname == "/special-services" ||
                pathname == "/create-order-services" ||
                showDropdown
                  ? "sidebar-tab active"
                  : "sidebar-tab"
              }
              onClick={toggleDropdown}
            >
              <DropdownButton
                className="sidebar-tabactive"
                key="end"
                id={`dropdown-button-drop-end`}
                drop="end"
                // onClick={toggleDropdown}
              >
                <Dropdown.Item eventKey="1">Account</Dropdown.Item>
                <Dropdown.Item eventKey="2" onClick={goToAccount}>
                  Client
                </Dropdown.Item>
                <Dropdown.Item eventKey="3" onClick={goToContractorAccount}>
                  Contractor
                </Dropdown.Item>
              </DropdownButton>
              <div className="sidebar-tab-icon">
                <img
                  // onClick={goToAccount}
                  src="./images/icons/sidebar-2.svg"
                  alt="icon"
                />
              </div>
              <p

              // onClick={goToAccount}
              >
                Account
              </p>
            </div>
            <div
              className={
                pathname == "/transation" || pathname == "/transation-detail"
                  ? "sidebar-tab active"
                  : "sidebar-tab"
              }
            >
              <div className="sidebar-tab-icon">
                <img
                  onClick={goToTransation}
                  src="./images/icons/sidebar-3.svg"
                  alt="icon"
                />
              </div>
              <p onClick={goToTransation}> Transactions </p>
            </div>

            <div
              className={
                pathname == "/invoice" || pathname == "/invoice-detail"
                  ? "sidebar-tab active"
                  : "sidebar-tab"
              }
            >
              <div className="sidebar-tab-icon">
                <img
                  onClick={goToInvoicePage}
                  src="./images/icons/sidebar-6.svg"
                  alt="icon"
                />
              </div>
              <p onClick={goToInvoicePage}> Invoices </p>
            </div>

            <div
              className={
                pathname == "/cleaner-payment" ||
                pathname == "/cleaner-payment-detail"
                  ? "sidebar-tab active"
                  : "sidebar-tab"
              }
            >
              <div className="sidebar-tab-icon">
                <img
                  onClick={goToReportsPage}
                  src="./images/icons/sidebar-7.svg"
                  alt="icon"
                />
              </div>
              <p onClick={goToReportsPage}> Cleaner Payment </p>
            </div>

            <div
              className={
                pathname == "/coupon" || pathname == "/create-coupon"
                  ? "sidebar-tab active"
                  : "sidebar-tab"
              }
            >
              <div className="sidebar-tab-icon">
                <img
                  onClick={goToCouponPage}
                  src="./images/icons/sidebar-5.svg"
                  alt="icon"
                />
              </div>
              <p onClick={goToCouponPage}>Coupon</p>
            </div>

            <div
              className={
                pathname == "/twofaguide" ||
                pathname == "/scan-qr" ||
                pathname == "/twofa-scurity" ||
                pathname == "/enter-twofa" ||
                pathname == "/disable-twofa" ||
                pathname == "/enable-twofa" ||
                pathname == "/disable-request"
                  ? "sidebar-tab active"
                  : "sidebar-tab"
              }
            >
              <div className="sidebar-tab-icon">
                <img
                  onClick={goToTwofa}
                  src="./images/icons/sidebar-4.svg"
                  alt="icon"
                />
              </div>
              <p onClick={goToTwofa}> 2 FA </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
